const LABEL_STYLE = {
    color: '#6c757d',
    letterSpacing: '.5px',
    fontSize: '.75rem',
};

const ConfirmPriceCheckbox = ({
    id = 'confirmPriceResponder',
    checked = false,
    onChange,
    title = '¿CUADRAN LOS PRECIOS?',
    description = 'Confirmo que el precio de la alternativa cuadra con el original',
}) => (
    <div className="col-md-12">
        <span className="d-block text-uppercase mb-2" style={LABEL_STYLE}>
            {title}
        </span>
        <div className="d-flex align-items-center gap-1 border rounded px-2 py-3">
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={(e) => onChange?.(e.target.checked)}
                style={{
                    accentColor: '#215732',
                    cursor: 'pointer',
                }}
            />
            <label htmlFor={id} style={{ cursor: 'pointer' }}>
                {description}
            </label>
        </div>
    </div>
);

export default ConfirmPriceCheckbox;
